export enum CustomerDiscountEnum {
  Part = 1,
  Material = 2,
  Category = 3,
}

export const customerDiscountMap: Record<number, string> = {
  [CustomerDiscountEnum.Part]: 'Part',
  [CustomerDiscountEnum.Material]: 'Material',
  [CustomerDiscountEnum.Category]: 'Category',
};
